/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./styles.css";

import {
  advancedFilterWorker,
  tableSkeleton
} from "../../constant/helper/helper";
import useSortableData from "../../customHooks/sortingHooks";
import { tableHeader } from "./userData";
import TableHeader from "../../component/tableHeader/TableHeader";
import isEmpty from "../../validation/isEmpty";
import { SHIFT_COLOR } from "../../constant/constant";

const UserList = ({
  Filter,
  allUsers,
  userLoading,
  setAllUsers,
  onResetPassword,
  onDeleteFace,
  reference,
  currentUser,
  dynamicHeader
}) => {
  const showUserList = (userArray, filterString) => {
    if (userLoading) {
      return <tr>{tableSkeleton(14 + dynamicHeader.length)}</tr>;
    } else if (
      typeof userArray !== "undefined" &&
      userArray !== null &&
      userArray.length > 0
    ) {
      const filteredUser = advancedFilterWorker(
        userArray,
        filterString,
        "fullNameAndId"
      );
      return filteredUser.map((singleUser, index) => {
        return (
          <tr
            key={index}
            style={{ fontSize: "12px" }}
            className={
              !singleUser.isActive ? "bg-danger text-white" : null
            }
          >
            <td className="">{index + 1}</td>
            <td className="text-center">
              <input
                type="checkbox"
                checked={singleUser.select}
                onChange={(e) => {
                  const value = e.target.checked;
                  setAllUsers(
                    filteredUser.map((clickUser) => {
                      if (clickUser._id === singleUser._id) {
                        clickUser.select = value;
                      }
                      return clickUser;
                    })
                  );
                }}
              />
            </td>
            <td className="text-center">
              <span
                className={
                  !singleUser.isActive
                    ? "badge badge-warning text-white"
                    : singleUser.allowFencing
                    ? "badge badge-success text-white"
                    : "badge badge-danger text-white"
                }
              >
                {singleUser.allowFencing ? "YES" : "NO"}
              </span>
            </td>
            <td className="text-center">
              <span
                className={
                  !singleUser.isActive
                    ? "badge badge-warning text-white"
                    : singleUser.workerFaceRegistered
                    ? "badge badge-success text-white"
                    : "badge badge-danger text-white"
                }
              >
                {singleUser.workerFaceRegistered ? "YES" : "NO"}
              </span>
            </td>
            <td className="text-center">
              <span
                className={
                  !singleUser.isActive
                    ? "badge badge-warning text-white"
                    : singleUser.isRestrict
                    ? "badge badge-success text-white"
                    : "badge badge-danger text-white"
                }
              >
                {singleUser.isRestrict ? "YES" : "NO"}
              </span>
            </td>
            <td className="text-center">
              <span
                className={
                  !singleUser.isActive
                    ? "badge badge-warning text-white"
                    : singleUser.isBackupDetectionImage
                    ? "badge badge-success text-white"
                    : "badge badge-danger text-white"
                }
              >
                {singleUser.isBackupDetectionImage ? "YES" : "NO"}
              </span>
            </td>
            <td className="">{singleUser.workerId}</td>
            <td className="text-center">
              <span
                className={
                  !isEmpty(singleUser.shiftCode)
                    ? SHIFT_COLOR[singleUser.shiftCode.trim()]
                    : ""
                }
              >
                {singleUser.shiftCode}
              </span>
            </td>
            <td>
              <Link
                to={`/hr/user/all-users/${singleUser._id}`}
                className={!singleUser.isActive ? "text-white" : null}
              >
                {singleUser.workerFullName}
              </Link>
            </td>
            <td className="" style={{ fontSize: 10 }}>
              {singleUser.workerDepartment}
            </td>
            <td className="" style={{ fontSize: 10 }}>
              {singleUser.workerDesignation}
            </td>
            <td className="" style={{ fontSize: 10 }}>
              {singleUser.locationName}
            </td>

            {!isEmpty(singleUser?.dataArray) &&
              singleUser.dataArray.map(
                (dynamicValue, dynamicValueIndex) => (
                  <td key={dynamicValueIndex}>
                    {dynamicValue.label === "Register Face Images"
                      ? !isEmpty(singleUser.registerFaceImages) &&
                        singleUser?.registerFaceImages.map(
                          (image, imageIndex) => (
                            <strong key={imageIndex}>
                              <a
                                href={image}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ fontSize: 10 }}
                              >
                                {" "}
                                Image No {imageIndex + 1},
                              </a>
                            </strong>
                          )
                        )
                      : dynamicValue.label === "Face Ids"
                      ? !isEmpty(singleUser.faceIds) &&
                        singleUser?.faceIds.map(
                          (faceId, faceIdIndex) => (
                            <strong key={faceIdIndex}>
                              {" "}
                              Id No {faceIdIndex + 1},
                            </strong>
                          )
                        )
                      : dynamicValue.label === "External Ids"
                      ? !isEmpty(singleUser.externalIds) &&
                        singleUser?.externalIds.map(
                          (externalId, externalIdIndex) => (
                            <strong key={externalIdIndex}>
                              {" "}
                              {externalId},
                            </strong>
                          )
                        )
                      : dynamicValue.label === "Image Ids"
                      ? !isEmpty(singleUser.imageIds) &&
                        singleUser?.imageIds.map(
                          (imageId, imageIdIndex) => (
                            <strong key={imageIdIndex}>
                              {" "}
                              Img Id{imageIdIndex + 1},
                            </strong>
                          )
                        )
                      : dynamicValue?.value || ""}
                  </td>
                )
              )}

            <td className="text-center">
              <button onClick={(e) => onResetPassword(e, singleUser)}>
                Reset
              </button>
            </td>
          </tr>
        );
      });
    } else if (userArray === null) {
      return (
        <tr>
          <td>
            <span className="">
              Please Select Location To see Records
            </span>
          </td>
        </tr>
      );
    } else if (userArray.length === 0) {
      return (
        <tr>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  const { items, requestSort, sortConfig } = useSortableData(
    allUsers
  );

  const renderDynamicHeader = (selectedValues) => {
    return selectedValues?.map(
      (headerDynamic, dynamicHeaderIndex) => {
        return (
          <th key={dynamicHeaderIndex}>{headerDynamic.label}</th>
        );
      }
    );
  };

  return (
    <div
      className="table-responsive"
      ref={reference}
      style={{ height: "700px", overflow: "auto" }}
    >
      <table
        className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
        id="products-datatable"
      >
        <thead className="thead-light">
          <tr>
            <th style={{ width: "20px" }}>#</th>
            <th className="text-center">
              <input
                type="checkbox"
                onChange={(e) => {
                  const value = e.target.checked;
                  setAllUsers(
                    allUsers.map((selectedUsers) => {
                      selectedUsers.select = value;
                      return selectedUsers;
                    })
                  );
                }}
              />
            </th>
            <th className="text-center">Geo Fencing</th>
            <th className="text-center">Face Register</th>
            <th className="text-center">Restriction</th>
            <th className="text-center">Backup Att</th>
            <TableHeader
              tableHeaderData={tableHeader}
              requestSort={requestSort}
              sortConfig={sortConfig}
            />
            <th>Last Location</th>
            {renderDynamicHeader(dynamicHeader)}
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>{showUserList(items, Filter)}</tbody>
      </table>
    </div>
  );
};

UserList.propTypes = {
  allUsers: PropTypes.array,
  onDeleteFace: PropTypes.func,
  currentUser: PropTypes.object,
  dynamicHeader: PropTypes.array,
  Filter: PropTypes.string.isRequired,
  reference: PropTypes.any.isRequired,
  userLoading: PropTypes.bool.isRequired,
  setAllUsers: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired
};

export default UserList;
